import { useCallback } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ArchitecturePage } from "@/components/architecture/architecture-page";
import {
  parseArchitectureSearch,
  type ArchitectureSearch,
} from "@/components/architecture/search";

export const Route = createFileRoute("/_app/$workspaceSlug/$projectSlug/architecture")({
  // Which view is shown lives in the URL and nowhere else. Whatever the URL
  // says, this returns a page that can be drawn: it never throws.
  validateSearch: (search: Record<string, unknown>): ArchitectureSearch =>
    parseArchitectureSearch(search),
  component: ArchitectureRoute,
});

function ArchitectureRoute() {
  const { projectSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (next: ArchitectureSearch) => void navigate({ search: next }),
    [navigate],
  );
  // Keyed by project: what is selected is one project's.
  return <ArchitecturePage key={projectSlug} search={search} onSearchChange={setSearch} />;
}
